export default __webpack_public_path__ + "static/TextFields-19e6601121419860d31b5fefa5a8efc7.png";